import './App.css';
import NavBar from './navBar';
import Home from "./pages/Home"
import Artwork from "./pages/Artwork"
import CodingProjects from "./pages/CodingProjects"
import GraphicDesign from "./pages/GraphicDesign"
import Contact from "./pages/Contact"
import ProjectPage from './pages/ProjectPage';
import { Route, Routes, useLocation } from "react-router-dom"
import { AnimatePresence } from 'framer-motion';
import { useEffect } from "react";


function App() {
  const location = useLocation();


  //Start at top of page when switching between pages
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  return (

    <>
        <NavBar />

        <div className="main-content">
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/artwork" element={<Artwork />} />
              <Route path="/codingProjects" element={<CodingProjects />} />
              <Route path="/graphicDesign" element={<GraphicDesign />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/graphicDesign/:page" element={<ProjectPage />} />
            </Routes>
          </AnimatePresence>
        </div>
    </>

 
  );
}

export default App;
